var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import './index.css';
import { Link, LinkController as BaseLinkController } from '@syllepsis/plugin-basic';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { InlineCard } from '../../card';
import { Modal, ModalContent, ModalFooter, ModalTitle } from '../../component/modal';
var PLUGIN_NAME = 'link';
var LinkComponent = /** @class */ (function (_super) {
    __extends(LinkComponent, _super);
    function LinkComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiddenTooltipTimer = null;
        _this.state = {
            showTooltip: false,
        };
        _this.showTooltipOnHover = function () {
            if (!_this.props.editor.editable)
                return;
            _this.cancelHideTooltip();
            if (_this.state.showTooltip === false) {
                _this.setState({ showTooltip: true });
            }
        };
        _this.hideTooltipWhenLeaveAsync = function () {
            if (_this.state.showTooltip === true) {
                _this.hiddenTooltipTimer = window.setTimeout(function () { return _this.setState({ showTooltip: false }); }, 300);
            }
        };
        _this.cancelHideTooltip = function () {
            if (typeof _this.hiddenTooltipTimer === 'number') {
                window.clearTimeout(_this.hiddenTooltipTimer);
                _this.hiddenTooltipTimer = null;
            }
        };
        _this.preventDefaultEvent = function (e) {
            if (!_this.props.editor.editable)
                return;
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        return _this;
    }
    LinkComponent.prototype.render = function () {
        var showTooltip = this.state.showTooltip;
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { key: "link-" + this.props.attrs.text, href: this.props.attrs.href, target: "_blank", rel: "nofollow", className: "syl-link", onMouseEnter: this.showTooltipOnHover, onMouseLeave: this.hideTooltipWhenLeaveAsync, onClick: this.preventDefaultEvent }, this.props.attrs.text),
            showTooltip &&
                ReactDOM.createPortal(React.createElement(LinkTooltip, __assign({ key: "linktooltip-" + this.props.attrs.text, hideTooltipWhenLeaveAsync: this.hideTooltipWhenLeaveAsync, cancelHideTooltip: this.cancelHideTooltip }, this.props)), this.props.editor.root)));
    };
    return LinkComponent;
}(React.PureComponent));
var LinkTooltip = function (props) {
    var _a = useState('hidden'), visibility = _a[0], setVisibility = _a[1];
    var tipRef = useRef(null);
    var _b = useState({}), position = _b[0], setPosition = _b[1];
    useEffect(function () {
        // ensure tooltip in visible area
        if (!tipRef.current)
            return;
        var rect = props.getBoundingClientRect();
        var $edit = props.editor.view.dom;
        var editRect = props.editor.view.dom.getBoundingClientRect();
        var width = tipRef.current.offsetWidth;
        var computedPos = { left: rect.left, top: rect.top - rect.height - 2 };
        if (rect.left + width > editRect.right)
            computedPos.left = editRect.width - width - 2;
        if (computedPos.top + (editRect.top - $edit.offsetTop) < 0)
            computedPos.top = rect.bottom + 2;
        setPosition(computedPos);
        setVisibility('visible');
    }, [tipRef]);
    return (React.createElement("span", { contentEditable: false, className: "syl-link-tooltip-wrapper syl-link-tooltip", style: __assign({ visibility: visibility }, position), ref: tipRef, onMouseEnter: props.cancelHideTooltip, onMouseLeave: props.hideTooltipWhenLeaveAsync },
        React.createElement("a", { href: props.attrs.href, target: "_blank" }, props.attrs.href)));
};
var LinkSchema = /** @class */ (function (_super) {
    __extends(LinkSchema, _super);
    function LinkSchema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            template: LinkComponent,
        };
        _this.NodeView = InlineCard.prototype.NodeView;
        return _this;
    }
    return LinkSchema;
}(Link));
var InsertType;
(function (InsertType) {
    InsertType["Insert"] = "insert";
    InsertType["Replace"] = "replace";
    InsertType["Selection"] = "selection";
})(InsertType || (InsertType = {}));
var LinkModal = /** @class */ (function (_super) {
    __extends(LinkModal, _super);
    function LinkModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            text: '',
            href: '',
            pos: 0,
            insertType: InsertType.Insert,
            errorText: '',
        };
        _this.handleClickOpen = function () {
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            _this.setState({ open: false });
        };
        _this.handleConfirm = function () {
            var _a = _this.state, text = _a.text, href = _a.href, insertType = _a.insertType, pos = _a.pos;
            var _b = _this.props, editor = _b.editor, validateHref = _b.validateHref;
            if (!editor)
                return;
            var newHref = href;
            if (validateHref) {
                var _c = validateHref(href), error = _c.error, result = _c.text, hrefAfterValidate = _c.href;
                if (error === false) {
                    newHref = hrefAfterValidate || href;
                }
                else if (result) {
                    _this.setState({
                        errorText: result,
                    });
                    return;
                }
            }
            var _d = editor.getSelection(), index = _d.index, length = _d.length;
            switch (insertType) {
                case InsertType.Insert:
                    _this.props.insert({ text: text, href: newHref });
                    break;
                case InsertType.Replace:
                    editor.updateCardAttrs(pos, { text: text, href: newHref });
                    break;
                case InsertType.Selection:
                    editor.replace({ type: PLUGIN_NAME, attrs: { text: text, href: newHref } }, { index: index, length: length });
                    break;
                default:
                    break;
            }
            setTimeout(function () {
                editor.focus();
                editor.setSelection({ index: index + 1, length: 0 });
            });
            _this.setState({ open: false });
        };
        _this.onEnterKeyup = function (e) {
            if (e.keyCode === 13 || e.key === 'Enter')
                _this.handleConfirm();
        };
        return _this;
    }
    LinkModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, text = _a.text, href = _a.href, insertType = _a.insertType, errorText = _a.errorText;
        var editor = this.props.editor;
        var locale = editor.configurator.getLocaleValue(PLUGIN_NAME);
        return (React.createElement(Modal, { isOpen: this.state.open, onClose: this.handleClose },
            React.createElement(ModalTitle, null, insertType === InsertType.Replace
                ? locale.editLinkTitle || '插入链接'
                : locale.insertLinkTitle || '修改链接'),
            React.createElement(ModalContent, null,
                React.createElement("input", { placeholder: locale.textPlaceholder || '链接文字', name: "text", value: text, onChange: function (e) {
                        return _this.setState({
                            text: e.target.value,
                        });
                    }, autoFocus: true, onKeyUp: this.onEnterKeyup }),
                React.createElement("input", { placeholder: locale.linkPlaceholder || '链接地址', name: "href", value: href, onChange: function (e) {
                        return _this.setState({
                            href: e.target.value,
                        });
                    }, onKeyUp: this.onEnterKeyup }),
                React.createElement("div", { className: "form-explain" }, errorText ? errorText : '')),
            React.createElement(ModalFooter, null,
                React.createElement("button", { onClick: this.handleClose, color: "primary", type: "button" }, locale.cancelText || '取消'),
                React.createElement("button", { onClick: this.handleConfirm, color: "primary", type: "button" }, locale.okText || '确认'))));
    };
    return LinkModal;
}(React.PureComponent));
var LinkController = /** @class */ (function (_super) {
    __extends(LinkController, _super);
    function LinkController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.modal = null;
        _this.eventHandler = {
            handleClickOn: function (editor, view, pos, node, nodePos, event) {
                if (!editor.editable)
                    return false;
                if (node.type.name === PLUGIN_NAME && _this.modal) {
                    // debugger;
                    event.preventDefault();
                    var _a = node.attrs, href = _a.href, text = _a.text;
                    _this.modal.setState({
                        text: text,
                        href: href,
                        pos: pos,
                        insertType: InsertType.Replace,
                        open: true,
                        errorText: '',
                    });
                }
                return false;
            },
        };
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            handler: function (editor) {
                if (_this.modal) {
                    var selectionObj = window.getSelection();
                    var text = selectionObj ? selectionObj.toString() : '';
                    var insertType = InsertType.Insert;
                    if (text) {
                        insertType = InsertType.Selection;
                    }
                    _this.modal.setState({
                        text: text,
                        insertType: insertType,
                        open: true,
                        href: '',
                        pos: 0,
                        errorText: '',
                    });
                }
            },
        };
        var extraDom = (React.createElement(LinkModal, { ref: function (el) {
                if (el) {
                    _this.modal = el;
                }
            }, validateHref: _this.validateHref, insert: _this.insert, editor: editor }));
        _this.modalContainer = document.createElement('div');
        document.body.appendChild(_this.modalContainer);
        ReactDOM.render(extraDom, _this.modalContainer);
        return _this;
    }
    LinkController.prototype.editorWillUnmount = function () {
        ReactDOM.unmountComponentAtNode(this.modalContainer);
    };
    return LinkController;
}(BaseLinkController));
export { LinkController, LinkSchema };
//# sourceMappingURL=link.js.map